import * as appsettings from '../../ts/pre-com/appsettings';
import * as form        from '../../ts/pre-com/form';

export function initialize_Login(): void {

    // Create new record ...
    $("#bttn-login").on("click", function (e: JQuery.ClickEvent) {

        // Prevent default behaviour
        e.preventDefault();
        submitLogin();
    });

    // Create new record ...
    $("#bttn-forgotpassword").on("click", function (e: JQuery.ClickEvent) {

        // Prevent default behaviour
        e.preventDefault();
        navigateToForgotPassword();
    });

    $("#UserName").on("keyup", function (event: JQuery.KeyUpEvent) {
        if (event.key === "Enter") {
            submitLogin();
            $("#UserName").trigger("blur");
        }
    });

    $("#Password").on("keyup", function (event: JQuery.KeyUpEvent) {
        if (event.key === "Enter") {
            submitLogin();
            $("#Password").trigger("blur");
        }
    });
}

export function setPasswordEditor(container: any, options: any): void {
    $('<input type="password" id="Password" name="' + options.field + '" title="Password" required="required" autocomplete="off" aria-labelledby="Password-form-label" data-bind="value: Password" aria-describedby="Password-form-hint"/>')
        .appendTo(container)
        .kendoTextBox();
}

export function onFormValidateField(e: any): void {
    $("#validation-success").html("");
}

export function onFormSubmit(e: any): void {
}

export function onFormClear(e: any): void {
    $("#validation-success").html("");
}

export function onForm_ResetPassword_Submit(e: any): void {
}

export function onForm_ResetPassword_Clear(e: any): void {
    $("#validation-success").html("");
}

export function onForm_ResetPassword_ValidateField(e: any): void {
    $("#validation-success").html("");
}

export function navigateToLogin(): void {
    window.location.assign(appsettings.getUrl("Account/Login"));
}

export function navigateToForgotPassword(): void {
    window.location.assign(appsettings.getUrl("Account/ForgotPassword"));
}

export function submitLogin(): void {
    form.submitForm("frmLogin", "Account/PostLogin", false, null);
}

export function onChangeLanguageSetting(element: HTMLSelectElement): void {

    const selected_culture = $("#cultureSetting").val();

    // change on client side browser
    switch (selected_culture) {
        case "nl-NL":
            //require("@progress/kendo-ui/js/messages/kendo.messages.nl-NL")
            break;
        case "en-EN":
            //require("@progress/kendo-ui/js/messages/kendo.messages.en-US")
            break;
        case "de-DE":
            //require("@progress/kendo-ui/js/messages/kendo.messages.de-DE")
            break;
    }

    element.form.submit();
}

export function redirectToExternalIdentityProvider(identityProviderId: number, returnUrl: string): void {

    //Set cookie auto login with SSO
    setLoginCookie("UseExternalLoginAutomatic", true, 365);

    //Usage IdentityProvider and ReturnUrl (for future use).
    setLoginCookie("UseExternalLoginAutomaticIdentityProviderId", identityProviderId, 365);
    setLoginCookie("UseExternalLoginAutomaticIdentityReturnUrl", returnUrl, 365);

    // redirect
    location.href = appsettings.getUrl('Auth/InitiateSingleSignOn?identityProviderId=' + identityProviderId + '&returnUrl=' + returnUrl);
}

///
/// Set Login Cookie 
///
export function setLoginCookie(cname: string, cvalue: boolean|number|string, exdays: number): void  {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

